import { produce } from "immer";

import {
  resetChangeTickets,
  updateChangeTickets,
  changeSeatNumberChangeTickets,
  updateSeatPlanChangeTickets,
  updateBicyclesChangeTickets,
  updateTransfersChangeTickets,
} from "./actions";

const initialChangeTicketsState = {
  // modals
  isBasketExrpired: false,
  isSomethingWrong: false,
  isSomethingWrongMessage: "",
  isSomethingWrongTitle: "",

  // tickets search
  lastSearch: "",
  isOpenBlind: false,
  isOutboundSelected: false, // new
  isInboundSelected: false, // new

  // seat details
  isOutbound: true,
  activeBus: 1,
  activePassenger: 1,
  passengersCount: 1, // need remove

  passengerDetailsStepDisabled: true,
  seatDetailsStepDisabled: true,

  basketCode: "",
  basketId: "",

  // isBasketTimeOut: false,

  // vouchers
  vouchers: {
    fullyCoversCost: false,
    totalVouchersValue: 0,
    showVoucherInput: false,
    approved: [],
    newVoucher: "",
    newVoucherValue: 0,
    statusVaucher: "",
  },

  totalPrice: null,
  prices: {},
  inbound: {
    selected: false,
  },
  outbound: {
    selected: false,
  },
  isPassengersInfoConfirmed: false,
  step: 2,

  passsengersInfo: {},
  isConfirmLeaveFromTicketFlow: false,
  // isCorporate: false,

  // currency: "CURRENCY.EUR",
  // currencyName: "EUR",
  // symbol: "€",
  showCurrencies: true,
  inboundJourneyPriceClass: "Regular",
  outboundJourneyPriceClass: "Regular",

  passengerPrices: [],
  passengersFee: 0,
  paymentSuccessful: false,
  basketTransfers: [],
  basketTransfersPrice: 0,
  hasTransfers: false,
  hasOutboundBicycles: false,
  hasInboundBicycles: false,
  forAnalitics: {},
  trip: {},
  GTM: {
    selectSeatsStep: false,
    passengerInfoStep: false,
    paymentStep: false,
    thanksStep: false,
  },
  affiliateId: "",
  transfers: {
    called: false,
    isOutbound: false,
    isInbound: false,
    inboundInformation: {},
    outboundInformation: {},
    InboundJourneys: [],
    OutboundJourneys: [],
    isOutboundOther: false,
    isInboundOther: false,
    outboundTransfer: {
      TransferId: "",
      PassengerName: "",
      PassengerPhone: "",
      Quantity: 1,
    },
    inboundTransfer: {
      TransferId: "",
      PassengerName: "",
      PassengerPhone: "",
      Quantity: 1,
    },
  },
  bicycles: {
    info: {},
    called: false,
    isOutbound: false,
    isInbound: false,
    outboundBicycle: {
      Quantity: 1,
      reserved: 0,
    },
    inboundBicycle: {
      Quantity: 1,
      reserved: 0,
    },
  },
  refund: {
    ticketNumber: "",
    modificationInfo: null,
    isPublic: true,
  },
  payment: {
    status: "",
    type: "",
    objects: [],
  },
  // variables for logic partners buses
  selectedJourneyId: "",
  confirmPartnerBusNotice: false,
  seatPlan: {
    Legs: [],
  },
};

export const changeTicketsSlice = (set, gets) => ({
  ...initialChangeTicketsState,
});

export const changeTicketsActions = (set, get) => ({
  [resetChangeTickets]: (payload) => {
    set((state) => ({
      ...state,
      changeTickets: {
        ...initialChangeTicketsState,
        ...(payload || {}),
      },
    }));
  },
  [updateChangeTickets]: (payload) => {
    set((state) => ({
      ...state,
      changeTickets: {
        ...(state && state.changeTickets
          ? state.changeTickets
          : initialChangeTicketsState),
        ...(payload || {}),
      },
    }));
  },
  [updateBicyclesChangeTickets]: (payload) => {
    set((state) => ({
      ...state,
      changeTickets: {
        ...(state && state.changeTickets
          ? state.changeTickets
          : initialChangeTicketsState),
        bicycles: {
          ...(state && state.changeTickets && state.changeTickets.bicycles
            ? state.changeTickets.bicycles
            : initialChangeTicketsState.bicycles),
          ...(payload || {}),
        },
      },
    }));
  },
  [updateTransfersChangeTickets]: (payload) => {
    set((state) => ({
      ...state,
      changeTickets: {
        ...(state && state.changeTickets
          ? state.changeTickets
          : initialChangeTicketsState),
        transfers: {
          ...(state && state.changeTickets && state.changeTickets.transfers
            ? state.changeTickets.transfers
            : initialChangeTicketsState.transfers),
          ...(payload || {}),
        },
      },
    }));
  },
  [updateSeatPlanChangeTickets]: (payload) => {
    const { newLegs } = payload;
    set(
      produce((state) => {
        newLegs.forEach((leg) => {
          if (leg.IsOutbound) {
            state.changeTickets.products.OutboundJourneys[0].Legs[
              leg.OrderNumber - 1
            ].SeatPlan = leg;
          } else {
            state.changeTickets.products.InboundJourneys[0].Legs[
              leg.OrderNumber - 1
            ].SeatPlan = leg;
          }
        });
      }),
    );
  },
  [changeSeatNumberChangeTickets]: (payload) => {
    const { directions, activeLeg, activePassenger, passanger } = payload;

    const prices = passanger.Prices.filter(
      (price) => passanger.IsBusinessClass === price.IsBusinessClass,
    );

    const hasCampaign = prices.some((price) => price.IsCampaign);

    set(
      produce((state) => {
        state.changeTickets.products[directions][0].Legs[activeLeg].SeatInfo[
          activePassenger
        ] = {
          ...passanger,
          HasCampaign: hasCampaign,
          IsCampaign: hasCampaign,
        };
      }),
    );
  },
});
